module.exports = __webpack_public_path__ + "static/profile-24264f813f62b6f7ac58693cb199612c.png";